import React from 'react';

const Column = (props) => {
    const { children, additionalClasses } = props;
    return <div className={`column ${additionalClasses}`}>{children}</div>;
};

export default Column;
